// import store from '../store/index.js'	//vuex
import config from '@/config'
import w_md5 from '@/utils/w_md5'
import moment from 'moment'
export function getSignUrl(url){
  const appKey = `${config.ApiHeardParams.APP_KEY}`
	const salt = `${config.ApiHeardParams.SALT}`
	const appSecret = `${config.ApiHeardParams.APP_SECRET}`
	const timestamp = moment().format("x")
	const sign = w_md5.hex_md5_32Upper(appKey + appSecret + timestamp + salt)
	return  `${config.CXWAPI}${url}` + "?appKey=" + appKey + "&timestamp=" + timestamp +
		"&sign=" + sign
}


// WEBPACK FOOTER //
// ./src/utils/request.js